import { render, staticRenderFns } from "./HistoricalTransactionDetails.vue?vue&type=template&id=0f1ba465&"
import script from "./HistoricalTransactionDetails.vue?vue&type=script&lang=js&"
export * from "./HistoricalTransactionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports